import * as React from "react";

import type { AppDefinedVariables, Keys, Variant } from "./textInterfaces";

import { useTexts } from "./hooks/useTexts";

//TODO: Remove Text implementation since it's only used in HomePage and duplicates interfaces.

interface CommonProps {
  readonly variant?: Variant;
  readonly variables?: AppDefinedVariables;
}

interface SingleTextProps {
  readonly componentId: Keys;
}

interface MultipleTextProps {
  readonly componentId: Array<Keys>;
  readonly separator?: string | Array<string>;
}

type TextProps = CommonProps & (SingleTextProps | MultipleTextProps);

type AsProp<T extends React.ElementType> = {
  as?: T;
} & React.ComponentPropsWithoutRef<T>;

export const Text = <T extends React.ElementType>(
  props: AsProp<T> & TextProps,
): React.ReactElement => {
  const {
    as: As = "span",
    variables,
    variant,
    componentId,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    separator,
    ...rest
  } = props;
  const { getText, getTexts } = useTexts();

  const content = Array.isArray(componentId)
    ? getTexts(componentId, { variables, variant }, separator)
    : getText(componentId, { variables, variant });

  return <As {...rest}>{content}</As>;
};
